import { useState } from 'react'
import background from '../assets/images/blue.png';
import dots from '../assets/images/dots.png'
import { IoEyeOutline } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { usersignup } from '../Redux/Action/AuthAction';
import { PiEyeSlash } from "react-icons/pi";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import useTitle from '../Hooks/useTitle';

const Registartion = () => {
    useTitle('Registration');
    const { t } = useTranslation('signup');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showpassword, setpassword] = useState(false);
    const { loading } = useSelector((state) => state.Auth);
    const [admin, setadmin] = useState({
        name: "",
        email: "",
        phone: '',
        address: '',
        city: '',
        postal_code: '',
        password: "",
        password_confirmation: ''
    })
    const handlesubmit = (e) => {
        const validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobileRegex = /^[0-9]{10}$/;

        e.preventDefault();
        if (!admin.name || !admin.email || !admin.phone || !admin.address || !admin.city || !admin.postal_code || !admin.password || !admin.password_confirmation) {
            toast.error(t("error_msg"))
            return;
        }
        if (!admin.email.match(validRegex)) {
            toast.error(t("error_email"));
        }
        else if (admin.password !== admin.password_confirmation) {
            toast.error(t("error_psw"))
            return;
        }
        // else if (!admin.phone.match(mobileRegex)) {
        //     toast.error(t("error_phone"))
        //     return;
        // }
        else {
            dispatch(usersignup(admin)).then(() => {
                navigate("/");
            })
                .catch((error) => {
                    toast.error(Object.values(error.response.data.errors)[0][0] || t("toast_error"))
                })
        }
    }

    const handlepassword = () => {
        setpassword(!showpassword);
    }

    return (
        <div className="flex w-[100vw] h-[100vh]">
            <div className="hidden w-[35vw] h-[100vh] relative sm:hidden lg:block">
                <img src={background} alt="background" className='h-[100vh] w-full object-cover' />
                <div className='absolute top-10 right-[10%]'>
                    <img src={dots} alt="dots" />
                </div>

                <div className="absolute  lg:top-[22%] xl:top-[28%] text-center  grid gap-5 flex flex-col justify-items-center w-full xl:p-[50px] md:p-[30px] ">
                    <div className="">
                        <h1 className='font-[600] text-[48px] text-white md:text-[40px]'>{t('main_title')}</h1>
                        <div className="bg-[white] rounded-md w-[50px] h-[3px] mx-auto mt-2"></div>
                    </div>
                    <div className="grid gap-2 ">
                        <p className='text-center  text-[18px] font-[600] text-white  break-words '>{t("main_subtitle")}</p>
                        <p className='text-white font-[300] break-words  text-[15px]'>{t("description")}</p>
                    </div>
                    <Link to="/" className='text-[#3686ff] bg-white max-w-32 w-full h-[52px] rounded-[15px] mx-auto text-center flex items-center justify-center ' >{t("signin_button")}</Link>
                </div>


                <div className='absolute bottom-10 left-[10%]'>
                    <img src={dots} alt="dots" />
                </div>
            </div>

            {
                loading ?
                    (
                        <div className="w-full mx-[30px] mx-auto h-[100vh] flex justify-center items-center lg:w-[65vw] sm:mx-20">
                            <CircularProgress size="3rem" />
                        </div>
                    ) : (
                        <div className="w-full min-h-screen flex justify-center items-center bg-[#EDF4FF]">
                            <div className="w-full mx-auto bg-[#EDF4FF] px-[30px] py-[40px] lg:w-[65vw]">
                                <form onSubmit={handlesubmit} className="bg-white p-[20px] sm:p-[40px] rounded-[20px] w-full mt-[300px] sm:mt-0">
                                    <div className='grid gap-[32px]'>
                                        <div className="text-center w-full">
                                            <h1 className='font-[700] text-[#131415] text-[26px]'>{t("title")}</h1>
                                            <p className='text-[#535861]'>{t("subtitle")}</p>
                                        </div>
                                        <div className="grid gap-4 w-full sm:grid-cols-2"> {/* Ensures single column on mobile */}
                                            {[
                                                { label: "name_label", placeholder: "name_placeholder", name: "name" },
                                                { label: "email_label", placeholder: "email_placeholder", name: "email" },
                                                { label: "phone_label", placeholder: "phone_placeholder", name: "phone" },
                                                { label: "address_label", placeholder: "address_placeholder", name: "address" },
                                                { label: "city_label", placeholder: "city_placeholder", name: "city" },
                                                { label: "postal_code_label", placeholder: "postal_code_placeholder", name: "postal_code" }
                                            ].map((field, index) => (
                                                <div key={index} className="flex flex-col gap-2">
                                                    <span className='text-[14px] font-[500] text-[#131415] text-left'>{t(field.label)}</span>
                                                    <input type='text' placeholder={t(field.placeholder)} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-2 text-[14px] w-full' name={field.name} value={admin[field.name]} onChange={(e) => setadmin({ ...admin, [e.target.name]: e.target.value })} />
                                                </div>
                                            ))}
                                            <div className="flex flex-col gap-2 relative">
                                                <span className='text-[14px] font-[500] text-[#131415] text-left'>{t("password_label")}</span>
                                                <input type={showpassword ? 'text' : 'password'} placeholder={t("password_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-2 text-[14px] w-full' name="password" value={admin.password} onChange={(e) => setadmin({ ...admin, [e.target.name]: e.target.value })} />
                                                {showpassword ? <IoEyeOutline className='absolute top-11 right-3 text-black cursor-pointer' onClick={handlepassword} /> : <PiEyeSlash className='absolute top-11 right-3 text-black cursor-pointer' onClick={handlepassword} />}
                                            </div>
                                            <div className="flex flex-col gap-2 relative">
                                                <span className='text-[14px] font-[500] text-[#131415] text-left'>{t("confirm_password_label")}</span>
                                                <input type='password' placeholder={t("confirm_password_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-2 text-[14px] w-full' name="password_confirmation" value={admin.password_confirmation} onChange={(e) => setadmin({ ...admin, [e.target.name]: e.target.value })} />
                                            </div>
                                        </div>
                                        <button type="submit" className='bg-[#3686ff] text-white max-w-32 w-full h-[52px] rounded-[15px] mx-auto text-center flex items-center justify-center'>{loading ? t("signing_up") : t("signup_button")}</button>
                                    </div>
                                </form>
                                <p className="text-center text-sm text-[#535861] mt-4 w-full lg:hidden">{t("have_account")} <Link to="/" className="text-[#3686ff] font-medium">{t("signin_button")}</Link></p>
                            </div>
                        </div>
                    )
            }
        </div>
    )
}

export default Registartion
